import React, {useEffect, useState} from "react";
import {Container, Form, Row} from "react-bootstrap";

import DeclarationPopupTFAF from "./DeclarationPopupTFAF";
import {useSearchParams} from "react-router-dom";
import {CheckCircleIcon, CrossCircleIcon, GreenTickIcon} from "./common/TfafCommonComponent";
import TooltipTFAF from "./common/TooltipTFAF";
import {useLocation} from "react-use";
import SaveEmailQuote from "./SaveEmailQuote";
import NavigateMBI from "./NavigateMBI";
import NavigateAAMBI from "./NavigateAAMBI";
import {useFeature} from '../hooks/useFeature';
import gaspyLearnMore from '../images/gaspy-learn-more.jpg';

const PolicyDetailsTFAF = props => {
  const [showDeclStatement, setShowDeclStatement] = useState(false);
  const [declarationPopupShow, setDeclarationPopupShow] = useState(false);
  const [searchParams] = useSearchParams();
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const backgroundColorsMobile = ['white', '#F3F4F6'];
  let currentBackgroundColorMobileIndex = 0;
  const [isTurners, setIsTurners] = useState(false);
  const [selectedCover, setSelectedCover] = useState(''); // State to keep track of the selected radio button
  const [selectedTerm, setSelectedTerm] = useState();
  const [excess, setExcess] = useState(new Map());
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const location = useLocation();
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [defaultCoverExcess, setDefaultCoverExcess] = useState(new Map())
  const [hasErrors, setHasErrors] = useState(false);
  const [pageErrors, setPageErrors] = useState('');
  const isAAPath = props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER';
  const isVTNZPath = props.inputValues.source === 'VTNZ';
  const gaspyPromoEnabled = useFeature('gaspy-free-fuel-promo');
  const baseUrl = window.location.origin;

  const updateMap = (k, v) => {
    setExcess(excess.set(k, v));
  }

  const updateDefaultCoverExcessMap = (k, v) => {
    setDefaultCoverExcess(defaultCoverExcess.set(k, v));
  }

  const checkForErrors = () => {
    setHasErrors(false);
    setPageErrors('');
    if (props.inputValues.selectedTermAndCover === null
      || !props.inputValues.selectedTermAndCover.hasOwnProperty('coverName')
      || !props.inputValues.selectedTermAndCover.hasOwnProperty('coverCode')
      || !props.inputValues.selectedTermAndCover.hasOwnProperty('term')
      || !props.inputValues.selectedTermAndCover.coverName
      || props.inputValues.selectedTermAndCover.term === "0") {
      setPageErrors('Select cover, excess and term')
      setHasErrors(true);

      window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: 'Submit',
          status: 'Fail',
          virtualUrl: `${baseUrl}/mbi/step2`,
          pageTitle: 'Choose Your Cover ',
        });

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      return true;
    }

    if (props.inputValues.excess === 0) {
      setPageErrors('Please select a valid excess option')
      setHasErrors(true);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      return true;
    }
    return false;
  }
  const clickNext = () => {
    if (!checkForErrors()) {

      window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: 'Submit',
          status: 'Success',
          virtualUrl: `${baseUrl}/mbi/step2`,
          pageTitle: 'Choose Your Cover ',
        });

      handleClick(true);
    }
  }


  const formatClaimLimit = (cl) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',

      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return formatter.format(cl);
  }

  const defaultExcessSelection = (coverName) => {
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    if (cover) {
      for (let excessVar of cover.excesses) {
        if (excessVar.status == 'CONDITIONALLY_ACTIVE' || excessVar.status == 'ACTIVE') {
          updateDefaultCoverExcessMap(coverName, excessVar.excess);
        }
      }
    }
  }
  const saveAndEmailQuote = () => {
    if (!checkForErrors()) {
      handleClick(false);
      setShowEmailPopup(true);

      window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: 'Email My Quote Start',
          virtualUrl: `${baseUrl}/mbi/step2`,
          pageTitle: 'Choose Your Cover ',
        });

    }
  }
  useEffect(() => {
    if (props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverCode !== null) {

      handleExcessChange(props.inputValues.selectedTermAndCover.coverName, props.inputValues.excess);
      if (props.inputValues.selectedTermAndCover) {
        setSelectedCover(props.inputValues.selectedTermAndCover.coverName);
        setSelectedTerm(props.inputValues.selectedTermAndCover.term);
        updateMap(props.inputValues.selectedTermAndCover.coverName, props.inputValues.excess);

      }
      if (props.inputValues.selectedTermAndCover.coverName === props.cover1) {
        defaultExcessSelection(props.cover2);
      } else {
        defaultExcessSelection(props.cover1);
      }
    } else {
      defaultExcessSelection(props.cover1);
      defaultExcessSelection(props.cover2);
      setIsFirstTime(true);
    }

    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
    if (props.inputValues.source === 'TFAF') {
      setIsTurners(true);
    }
    // Track the 'page loaded' event
    if (window.gtag &&
      (window.location.href.includes("turnersinsurance.dplinsurance.co.nz/") ||
        window.location.href.includes("online") ||
        window.location.href.includes("mbi.aa.co.nz") ||
        window.location.href.includes("moneyhub") ||
        window.location.href.includes("myautoshop")
      )) {
      window.gtag('event', 'Page visited', {
        event_category: 'Page',
        event_label: 'Policy detail page',
      });
    }
    if (isAAPath) {
      // Push virtual pageview event to dataLayer for GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'virtualPageview',
        'virtualUrl': '/quotes',
        'pageTitle': 'Quotes'
      });
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Page View',
        virtualUrl: `${baseUrl}/mbi/step2`,
        pageTitle: 'Choose Your Cover ',
      });
    }
  }, []);

  const policyLink = () => {
    if (props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER') {
      return "https://docs.autosure.co.nz/policy_books/aa/mbi.pdf";
    } else {
      return "https://docs.autosure.co.nz/policy_books/turners/mbi.pdf";
    }
  }
  const getNextBackgroundColorMobile = () => {
    const nextColor = backgroundColorsMobile[currentBackgroundColorMobileIndex];
    currentBackgroundColorMobileIndex = (currentBackgroundColorMobileIndex + 1) % backgroundColorsMobile.length;
    return nextColor;
  };
  const steps = [// {name: 'Step 1', status: 'complete'},
    {name: 'Step 1', status: 'complete', desc: 'Car details'}, {
      name: 'Step 2', status: 'current', desc: 'Choose your cover'
    }, {name: 'Step 3', status: 'upcoming', desc: 'About you'}, {
      name: 'Step 4', status: 'upcoming', desc: 'Pay now'
    },];
  const handleExcessChange = (cover, upExcess) => {
    setSelectedCover(cover);
    setIsFirstTime(false);
    props.handleChangeValue('excess', upExcess);
    updateMap(cover, upExcess);
    let coverName = cover;
    let coverCode = getCoverCode(coverName);
    let term = props.inputValues.selectedTermAndCover.term;
    if (term === undefined && selectedTerm !== undefined && selectedTerm !== '') {
      term = selectedTerm;
    }
    handleRadioChange(cover, term);
    props.handleChangeValue('excess', excess.get(coverName));

    let catDetails = "$" + upExcess
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Excess Option',
        categoryDetails: catDetails,
        virtualUrl: `${baseUrl}/mbi/step2`,
        pageTitle: 'Choose Your Cover ',
      });

  }
  const handleNewQuoteClick = () => {
      window.location.href = '/mbi';
  };
  const handleClick = (showDeclaration) => {
    let id;
    if (props.inputValues.source === 'TFAF') {
      id = searchParams.get("id");
    } else {
      id = props.inputValues.id;
    }
    const aaMemberData = {
      aaMemberNumber: props.inputValues.aaMembershipNumber,
      lastName: props.inputValues.aaMemberLastName,
      dateOfBirth: props.inputValues.aaMemberDOB
    }
    const prospectData = {
      id: id,
      term: props.inputValues.selectedTermAndCover.term,
      premium: props.inputValues.selectedTermAndCover.premium,
      excess: props.inputValues.excess,
      code: props.inputValues.selectedTermAndCover.coverCode,
      name: props.inputValues.selectedTermAndCover.coverName,
      aaMemberData: aaMemberData
    };

    fetch(`${url}/campaign/policy-renewal/prospects`, {
      method: 'PUT',
      mode: "cors",
      headers: {
        'Content-Type': 'application/json',
        "Authorization": 'By-Pass-Auth-Create-Prospect'
      },
      body: JSON.stringify(prospectData)
    })
      .then((response) => response.json())
      .then((data) => {
        props.updateAmendQuoteResponse(JSON.stringify(data.amendQuoteResponse));
      })
      .catch((error) => {
        console.error('API call error:', error);
      });
    setDeclarationPopupShow(showDeclaration);
  }
  const getPremium1 = (coverName, term) => {
    let NZDollar = Intl.NumberFormat('en', {
      style: 'currency',
      currency: 'USD',
    });
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    if (cover) {

      let selectedExcess = null;
      for (let excessVar of cover.excesses) {
        if (selectedExcess == null && (excessVar.status === 'ACTIVE' || excessVar.status === 'CONDITIONALLY_ACTIVE')) {
          selectedExcess = excessVar;
        }
        if (isFirstTime) {
          if (excessVar.excess === defaultCoverExcess.get(coverName)) {
            selectedExcess = excessVar;
          }
        } else {
          if (excess.get(coverName) !== undefined) {
            if (excessVar.excess === excess.get(coverName)) {
              selectedExcess = excessVar;
            }
          } else {
            if (excessVar.excess === defaultCoverExcess.get(coverName)) {
              selectedExcess = excessVar;
            }
          }
        }
      }
      if (excess.get(coverName) != null && excess.get(coverName) === undefined && (selectedExcess.status === 'ACTIVE' || selectedExcess.status === 'CONDITIONALLY_ACTIVE')) {
        updateMap(coverName, selectedExcess.excess);
        props.handleChangeValue('excess', selectedExcess.excess);
      }
      const premium = selectedExcess.premiums.find(
        (p) => p.term.toString() === term
      );
      // Ensure premium object is not undefined and has valid retailAmount and discountedAmount
      if (premium) {
        const retailAmount = premium.retailAmount || 0; // Default to 0 if undefined
        const nonDiscountedAmount = premium.discountedAmount !== undefined ? premium.discountedAmount : null; // Default to null if undefined
        if (premium.discountedAmount !== null && props.inputValues.validAaMember !== 'YES') {
          props.handleChangeValue('validAaMember', 'YES');
        }
        // Return formatted values, ensure no NaN values are passed
        return {
          retailAmount,
          discountedAmount: nonDiscountedAmount,
          formattedRetailAmount: retailAmount ? NZDollar.format(retailAmount) : null,
          formattedNonDiscountedAmount: nonDiscountedAmount !== null ? NZDollar.format(nonDiscountedAmount) : null,
        };
      }
    }

    return null;
  };
  const getPremium = (coverName, term) => {
    let NZDollar = Intl.NumberFormat('en', {
      style: 'currency',
      currency: 'USD',
    });
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    if (cover) {

      let selectedExcess = null;
      for (let excessVar of cover.excesses) {
        if (selectedExcess == null && (excessVar.status === 'ACTIVE' || excessVar.status === 'CONDITIONALLY_ACTIVE')) {
          selectedExcess = excessVar;
        }
        if (isFirstTime) {
          if (excessVar.excess === defaultCoverExcess.get(coverName)) {
            selectedExcess = excessVar;
          }
        } else if (excess.get(coverName) !== undefined) {
          if (excessVar.excess === excess.get(coverName)) {
            selectedExcess = excessVar;
          }
        }
      }
      if (excess.get(coverName) != null && excess.get(coverName) === undefined && (selectedExcess.status === 'ACTIVE' || selectedExcess.status === 'CONDITIONALLY_ACTIVE')) {
        updateMap(coverName, selectedExcess.excess);
        props.handleChangeValue('excess', selectedExcess.excess);
      }
      const premium = selectedExcess.premiums.find(
        (p) => p.term.toString() === term
      );


      return premium ? NZDollar.format(premium.retailAmount) : null;
    }
    return null;
  };

  const getClaimLimitForCover = (coverName) => {
    const cover = props.parentAmendQuoteResponse.covers.find((cover) => cover.coverName === coverName);
    if (cover && cover.excesses && cover.excesses.length > 0) {
      return cover.excesses[0].claimLimit;
    }
    return null;
  };
  const getExcess = (coverName, excessUpdated) => {
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    let excesses = [];
    if (cover) {
      for (let excessVar of cover.excesses) {
        if (excessVar.status == 'CONDITIONALLY_ACTIVE' || excessVar.status == 'ACTIVE') {
          excesses.push(excessVar.excess);
        }
      }
    }
    return excesses;

  };
  const getStatus = (coverName) => {

    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );

    if (cover) {
      let status = cover.excesses[0].status;
      for (let i = 0; i < cover.excesses.length; i++) {
        if (cover.excesses[i].status == 'CONDITIONALLY_ACTIVE' || cover.excesses[i].status == 'ACTIVE') {
          status = cover.excesses[i].status;
        }
      }
      return status;
    }

    return "NA";
  };
  const isActive = (coverName) => {
    return getStatus(coverName) === 'ACTIVE' || getStatus(coverName) === 'CONDITIONALLY_ACTIVE';
  }
  const getClaimLimit = (coverName, selectedExcess) => {
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );

    if (cover) {
      let excessFound = null;
      if (selectedExcess === undefined) {
        excessFound = cover.excesses[0];
      } else {
        excessFound = cover.excesses.find(
          (ex) => ex.excess === selectedExcess
        );
      }
      if (excessFound) {
        if (isNaN(excessFound.claimLimit)) {
          return excessFound.claimLimit;
        } else {
          return 'Up to ' + formatClaimLimit(excessFound.claimLimit);
        }
      }
    }

    return "NA";
  };
  const getBenefitDescription = (cover, type) => {
    return JSON.parse(props.inputValues.additionalBenefit.get(cover)).find((ab) => ab.name === type).description;
  }
  const handleRadioChange = (coverName, term) => {

    let catDetails = coverName + " - " + (term / 12) + " year"
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Select your Term & Premium',
        categoryDetails: catDetails,
        virtualUrl: `${baseUrl}/mbi/step2`,
        pageTitle: 'Choose Your Cover ',
      });

    if (isFirstTime) {
      updateMap(coverName, defaultCoverExcess.get(coverName));
    }
    props.parentQuote.cover = coverName;
    props.parentQuote.term = term;
    props.parentQuote.premium = getPremium(coverName, term);
    props.parentQuote.claimLimit = getClaimLimitForCover(coverName);
    let premium = getPremium(coverName, term);
    setSelectedCover(coverName);
    setSelectedTerm(term);
    let coverCode = getCoverCode(coverName);
    props.inputValues.selectedTermAndCover = {coverName, coverCode, term, premium};
    props.handleChangeValue("selectedTermAndCover", props.inputValues.selectedTermAndCover);
    let selectedExcess = excess.get(coverName)

    if (selectedExcess === undefined) {
      selectedExcess = defaultCoverExcess.get(coverName);
    }
    props.handleChangeValue('excess', selectedExcess);
    setIsFirstTime(false);
  };

  const getCoverCode = (coverName) => {
    const cover = props.parentAmendQuoteResponse.covers.find(
      (cover) => cover.coverName === coverName
    );
    return cover.coverCode;
  }
  const isHighlighted = (coverName) => {
    return coverName === selectedCover;
  };
  return (
    <Container className='container-padding'
               style={{
                 marginBottom: '100px',
               }}>
      <br/>
      
      <Row className="justify-content-center">
        {isAAPath ? (
          <NavigateAAMBI steps={steps}/>
        ) : (
          <NavigateMBI steps={steps}/>
        )}
      </Row>

      <div className="regularErrorStyleCenter">{pageErrors}</div>
      <br/>
      <div id="full-table" className="flex-display"
           style={{
             display: 'flex',
             flexDirection: 'row',
             gap: '129px',
             justifyContent: 'center',
           }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '838.16p',
            borderRadius: '10px',
            justifyContent: "space-between",
            alignItems: 'center',
          }}>
          <p className="subHeadingStyles">Quote</p>
        </div>

      </div>
      {props.inputValues.validAaMember === 'YES' && props.inputValues.aaMember === 'YES' &&
        <div id="full-table" className="flex-display"
             style={{
               display: 'flex',
               flexDirection: 'row',
               gap: '129px',
               justifyContent: 'center',
             }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '838.16p',
              borderRadius: '10px',
              justifyContent: "space-between",
              alignItems: 'center',
            }}>
            <p className="subSmallHeadingStyles">

              <GreenTickIcon/>&nbsp;We've applied your AA Member discount</p>
          </div>
        </div>}

      {/*mobile view*/
      }
      <div id="mobile-table"
           style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div style={{maxWidth: '838.16px', width: "100%"}}>
          {/*combined cover*/}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '-1px 1px 5px 6px rgba(0,0,0,0.06)',
              // border: '2px solid transparent',
              borderRadius: '10px',
              // border: (isHighlighted(props.cover2) || isHighlighted(props.cover1)) ? '5px solid #006EB8' : '2px solid transparent',
              // border: isAAPath ? '10px solid #ffd400' : (isHighlighted(props.cover2) || isHighlighted(props.cover1)) ? '5px solid #006EB8' : '2px solid transparent',
              border: props.inputValues.selectedTermAndCover.coverName ? isAAPath ? '10px solid #ffd400' : '5px solid #006EB8' : '2px solid transparent',
            }}>

            <div className="mobile-cover-display-old"
                 style={
                   (isActive(props.cover2)) ||
                   (isActive(props.cover1)) ? {display: "flex"} : {}
                 }>
              <div className="aaBoldTextStyles" style={{
                height: '100px',
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: 'left',
                color: isAAPath ? "#005B88" : "white",
                flex: 1
              }}>
                Select your Term & Premium
              </div>
              {(isActive(props.cover1)) && (
                <div style={{
                  height: '100px',
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: 'center',
                  flex: 1
                }}>
                  <div className="subHeadingWhiteTextStyles regularSubHeadingStyles">
                    {props.cover1}
                  </div>
                </div>)}
              {(isActive(props.cover2)) && (

                <div style={{
                  height: '100px',
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: 'center',
                  flex: 1
                }}>
                  <div className="subHeadingWhiteTextStyles regularSubHeadingStyles">
                    {props.cover2}
                  </div>
                </div>)}
            </div>
            <div style={{display: "flex", background: isAAPath ? "white" : '#F3F4F6'}}><br/></div>
            <div style={{display: "flex", background: isAAPath ? "white" : '#F3F4F6'}}>
              <div style={{flex: 1}}>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background: isAAPath ? "white" : '#F3F4F6',
                }}>1 year
                </div>
                <br/>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background: isAAPath ? "white" : '#F3F4F6'
                }}>2 year
                </div>
                <br/>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background: isAAPath ? "white" : '#F3F4F6'
                }}>3 year
                </div>
                <br/>
                {((isActive(props.cover1) ? getPremium1(props.cover1, "48") : null) ||
                  (isActive(props.cover2) ? getPremium1(props.cover2, "48") : null)) && <>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: isAAPath ? "white" : '#F3F4F6'
                  }}>4 year
                  </div>
                </>}
              </div>
              {(isActive(props.cover1)) && (
                <div style={{flex: 1}}
                     className="regularTextStyles">
                  <Form.Group style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: isAAPath ? "white" : '#F3F4F6',
                  }}>
                    <Form.Check type="radio"
                                label={<span>
                                      <span className="boldTextStyles">
                                        {getPremium1(props.cover1, "12") ? (<>
                                          {getPremium1(props.cover1, "12").discountedAmount !== null ? (<>
                                            {/* Retail amount with strike-through and discounted amount */}
                                            <span className="regularTextStyles"
                                                  style={{
                                                    textDecoration: "line-through",
                                                    marginRight: "8px"
                                                  }}>
                                                  {getPremium1(props.cover1, "12").formattedNonDiscountedAmount}
                                                </span>
                                            <br/>
                                            <span
                                            >
                                                  {getPremium1(props.cover1, "12").formattedRetailAmount}
                                                </span>
                                          </>) : (// If no discount, just show the retail amount
                                            <>
                                                <span>
                                                {getPremium1(props.cover1, "12").formattedRetailAmount}
                                                </span>
                                              <div><br/></div>
                                            </>)}
                                        </>) : (// Fallback if no premium data is available
                                          <span>NA</span>)}
                                      </span>


                                    </span>}
                                className="quoteCheckbox"
                                id="cover1_12"
                                onChange={() => handleRadioChange(props.cover1, "12")}
                                checked={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover1 && props.inputValues.selectedTermAndCover.term === "12"}
                    />
                    <Form.Check type="radio"
                                className="quoteCheckbox"
                                label={<span>
                                      <span className="boldTextStyles">
                                        {getPremium1(props.cover1, "24") ? (<>
                                          {getPremium1(props.cover1, "24").discountedAmount !== null ? (<>
                                            {/* Retail amount with strike-through and discounted amount */}
                                            <span className="regularTextStyles"
                                                  style={{
                                                    textDecoration: "line-through",
                                                    marginRight: "8px"
                                                  }}>
                                                  {getPremium1(props.cover1, "24").formattedNonDiscountedAmount}
                                                </span>
                                            <br/>
                                            <span>
                                                  {getPremium1(props.cover1, "24").formattedRetailAmount}
                                                </span>
                                          </>) : (// If no discount, just show the retail amount
                                            <>
                                                <span>
                                                {getPremium1(props.cover1, "24").formattedRetailAmount}
                                              </span>
                                              <div><br/></div>
                                            </>
                                          )}
                                        </>) : (// Fallback if no premium data is available
                                          <>
                                            <span>NA</span>
                                            <div><br/></div>
                                          </>)}
                                      </span>
                                    </span>}
                                id="cover1_24"
                                onChange={() => handleRadioChange(props.cover1, "24")}
                                checked={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover1 && props.inputValues.selectedTermAndCover.term === "24"}

                    />
                    <Form.Check type="radio"
                                className="quoteCheckbox"
                                label={<span>
                                      <span className="boldTextStyles">
                                        {getPremium1(props.cover1, "36") ? (<>
                                          {getPremium1(props.cover1, "36").discountedAmount !== null ? (<>
                                            {/* Retail amount with strike-through and discounted amount */}
                                            <span
                                              className="regularTextStyles"
                                              style={{
                                                textDecoration: "line-through",
                                                marginRight: "8px"
                                              }}>
                                                  {getPremium1(props.cover1, "36").formattedNonDiscountedAmount}
                                                </span><br/>
                                            <span>
                                                  {getPremium1(props.cover1, "36").formattedRetailAmount}
                                                </span>
                                          </>) : (// If no discount, just show the retail amount
                                            <>
                                                <span>
                                                {getPremium1(props.cover1, "36").formattedRetailAmount}
                                              </span>
                                              <div><br/></div>
                                            </>)}
                                        </>) : (// Fallback if no premium data is available
                                          <span>NA</span>)}
                                      </span>
                                    </span>}
                                id="cover1_36"
                                onChange={() => handleRadioChange(props.cover1, "36")}
                                checked={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover1 && props.inputValues.selectedTermAndCover.term === "36"}
                    />
                    {getPremium1(props.cover1, "48") && <>
                      <Form.Check type="radio"
                                  className="quoteCheckbox"
                                  label={<span>
                                      <span className="boldTextStyles">
                                        {getPremium1(props.cover1, "48") ? (<>
                                          {getPremium1(props.cover1, "48").discountedAmount !== null ? (<>
                                            {/* Retail amount with strike-through and discounted amount */}
                                            <span className="regularTextStyles"
                                                  style={{
                                                    textDecoration: "line-through",
                                                    marginRight: "8px"
                                                  }}>
                                                  {getPremium1(props.cover1, "48").formattedNonDiscountedAmount}
                                                </span>
                                            <br/>
                                            <span>
                                                  {getPremium1(props.cover1, "48").formattedRetailAmount}
                                                </span>
                                          </>) : (// If no discount, just show the retail amount
                                            <>
                                                <span>
                                                {getPremium1(props.cover1, "48").formattedRetailAmount}
                                              </span>
                                              <div><br/></div>
                                            </>)}
                                        </>) : (// Fallback if no premium data is available
                                          <span>NA</span>)}
                                      </span>
                                    </span>}
                                  id="cover1_48"
                                  onChange={() => handleRadioChange(props.cover1, "48")}
                                  checked={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover1 && props.inputValues.selectedTermAndCover.term === "48"}
                                  disabled={!getPremium(props.cover1, "48")}
                      />
                    </>}
                  </Form.Group>

                </div>)}
              {(isActive(props.cover2)) && (
                <div style={{flex: 1}}
                     className="regularTextStyles">
                  <Form.Group style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: isAAPath ? "white" : '#F3F4F6',
                  }}>
                    <Form.Check type="radio"
                                className="quoteCheckbox"
                                label={<span>
                                      <span className="boldTextStyles">
                                        {getPremium1(props.cover2, "12") ? (<>
                                          {getPremium1(props.cover2, "12").discountedAmount !== null ? (<>
                                            {/* Retail amount with strike-through and discounted amount */}
                                            <span className="regularTextStyles"
                                                  style={{
                                                    textDecoration: "line-through",
                                                    marginRight: "8px"
                                                  }}>
                                                  {getPremium1(props.cover2, "12").formattedNonDiscountedAmount}
                                                </span>
                                            <br/>
                                            <span>
                                                  {getPremium1(props.cover2, "12").formattedRetailAmount}
                                                </span>
                                          </>) : (// If no discount, just show the retail amount
                                            <>
                                                <span>
                                                {getPremium1(props.cover2, "12").formattedRetailAmount}
                                              </span>
                                              <div><br/></div>
                                            </>)}
                                        </>) : (// Fallback if no premium data is available
                                          <span>NA</span>)}
                                      </span>
                                    </span>}
                                id="cover2_12"
                                onChange={() => handleRadioChange(props.cover2, "12")}
                                checked={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover2 && props.inputValues.selectedTermAndCover.term === "12"}
                    />
                    <Form.Check type="radio"
                                className="quoteCheckbox"
                                label={<span>
                                      <span className="boldTextStyles">
                                        {getPremium1(props.cover2, "24") ? (<>
                                          {getPremium1(props.cover2, "24").discountedAmount !== null ? (<>
                                            {/* Retail amount with strike-through and discounted amount */}
                                            <span className="regularTextStyles"
                                                  style={{
                                                    textDecoration: "line-through",
                                                    marginRight: "8px"
                                                  }}>
                                                  {getPremium1(props.cover2, "24").formattedNonDiscountedAmount}
                                                </span>
                                            <br/>
                                            <span>
                                                  {getPremium1(props.cover2, "24").formattedRetailAmount}
                                                </span>
                                          </>) : (// If no discount, just show the retail amount
                                            <>
                                                <span>
                                                {getPremium1(props.cover2, "24").formattedRetailAmount}
                                              </span>
                                              <div><br/></div>
                                            </>)}
                                        </>) : (// Fallback if no premium data is available
                                          <span>NA</span>)}
                                      </span>
                                    </span>}
                                id="cover2_24"
                                onChange={() => handleRadioChange(props.cover2, "24")}
                                checked={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover2 && props.inputValues.selectedTermAndCover.term === "24"}
                    />
                    <Form.Check type="radio"
                                className="quoteCheckbox"
                                label={<span>
                                      <span className="boldTextStyles">
                                        {getPremium1(props.cover2, "36") ? (<>
                                          {getPremium1(props.cover2, "36").discountedAmount !== null ? (<>
                                            {/* Retail amount with strike-through and discounted amount */}
                                            <span className="regularTextStyles"
                                                  style={{
                                                    textDecoration: "line-through",
                                                    marginRight: "8px"
                                                  }}>
                                                  {getPremium1(props.cover2, "36").formattedNonDiscountedAmount}
                                                </span>
                                            <br/>
                                            <span>
                                                  {getPremium1(props.cover2, "36").formattedRetailAmount}
                                                </span>
                                          </>) : (// If no discount, just show the retail amount
                                            <>
                                                <span>
                                                {getPremium1(props.cover2, "36").formattedRetailAmount}
                                              </span>
                                              <div><br/></div>
                                            </>)}
                                        </>) : (// Fallback if no premium data is available
                                          <span>NA</span>)}
                                      </span>
                                    </span>}
                                id="cover2_36"
                                onChange={() => handleRadioChange(props.cover2, "36")}
                                checked={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover2 && props.inputValues.selectedTermAndCover.term === "36"}
                    />
                    {getPremium(props.cover2, "48") && <>
                      <Form.Check type="radio"
                                  className="quoteCheckbox"
                                  label={<span>
                                      <span className="boldTextStyles">
                                        {getPremium1(props.cover2, "48") ? (<>
                                          {getPremium1(props.cover2, "48").discountedAmount !== null ? (<>
                                            {/* Retail amount with strike-through and discounted amount */}
                                            <span className="regularTextStyles"
                                                  style={{textDecoration: "line-through", marginRight: "8px"}}
                                            >
                                                  {getPremium1(props.cover2, "48").formattedNonDiscountedAmount}
                                                </span><br/>
                                            <span>
                                                  {getPremium1(props.cover2, "48").formattedRetailAmount}
                                                </span>

                                          </>) : (// If no discount, just show the retail amount
                                            <>
                                                <span>
                                                {getPremium1(props.cover2, "48").formattedRetailAmount}
                                              </span>
                                              <div><br/></div>
                                            </>)}
                                        </>) : (// Fallback if no premium data is available
                                          <span>NA</span>)}
                                      </span>
                                    </span>}
                                  id="cover2_48"
                                  onChange={() => handleRadioChange(props.cover2, "48")}
                                  checked={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover2 && props.inputValues.selectedTermAndCover.term === "48"}
                                  disabled={!getPremium(props.cover2, "48")}
                      />
                    </>}
                  </Form.Group>
                </div>
              )}
            </div>
            <div style={{display: "flex", background: isAAPath ? "white" : '#F3F4F6'}}><br/></div>
            <div
              style={{
                background: isAAPath ? '#F3F4F6' : '#B3D6EC',
                textAlign: 'center',
                color: isAAPath ? '#005B88' : '#0C2F63',
                paddingRight: '10px',
              }}>
              <div style={(isActive(props.cover2)) &&
              (isActive(props.cover1)) ? {display: "flex", justifyContent: "center"} : {
                display: "grid",
                justifyContent: "center"
              }}>
                <div className="boldTextStyles"
                     style={{
                       display: "flex",
                       justifyContent: "center",
                       alignItems: "center",
                       flex: 1
                     }}>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2802_3718)">
                      <path
                        d="M18.375 1.70728H5.625C5.00156 1.70728 4.5 2.20884 4.5 2.83228V10.637L3.63281 9.91978C3.43594 9.7604 3.225 9.62446 3 9.51665V2.83228C3 1.38384 4.17656 0.207275 5.625 0.207275H18.375C19.8234 0.207275 21 1.38384 21 2.83228V9.51665C20.775 9.62446 20.5641 9.7604 20.3719 9.91978L19.5 10.637V2.83228C19.5 2.20884 18.9984 1.70728 18.375 1.70728ZM1.64062 12.2073C1.56562 12.2073 1.5 12.2682 1.5 12.3479V21.2073C1.5 22.037 2.17031 22.7073 3 22.7073H21C21.8297 22.7073 22.5 22.037 22.5 21.2073V12.3479C22.5 12.2729 22.4391 12.2073 22.3594 12.2073C22.3266 12.2073 22.2984 12.2167 22.2703 12.2401L13.8047 19.1963C13.2984 19.6135 12.6562 19.8432 12 19.8432C11.3438 19.8432 10.7016 19.6135 10.1953 19.1963L1.725 12.2401C1.70156 12.2213 1.66875 12.2073 1.63594 12.2073H1.64062ZM0 12.3479C0 11.4432 0.73125 10.7073 1.64062 10.7073C2.02031 10.7073 2.38594 10.8385 2.68125 11.0776L11.1469 18.0338C11.3859 18.2307 11.6906 18.3385 12 18.3385C12.3094 18.3385 12.6141 18.2307 12.8531 18.0338L21.3234 11.0776C21.6187 10.8385 21.9844 10.7073 22.3641 10.7073C23.2688 10.7073 24.0047 11.4385 24.0047 12.3479V21.2073C24.0047 22.862 22.6594 24.2073 21.0047 24.2073H3C1.34531 24.2073 0 22.862 0 21.2073V12.3479ZM12.75 4.33228V5.14321C13.1484 5.19946 13.5328 5.28853 13.8797 5.38228C14.2781 5.49009 14.5172 5.8979 14.4094 6.30103C14.3016 6.70415 13.8937 6.93853 13.4906 6.83071C12.9703 6.69009 12.4594 6.58696 11.9859 6.58228C11.5922 6.57759 11.1703 6.66665 10.8797 6.84009C10.6125 6.99946 10.5 7.18228 10.5 7.44009C10.5 7.61353 10.5609 7.74478 10.8422 7.91353C11.1656 8.10571 11.6203 8.24634 12.2109 8.42446L12.2344 8.42915C12.7641 8.58852 13.4203 8.7854 13.9359 9.11353C14.5031 9.46978 14.9859 10.037 15 10.9042C15.0141 11.8088 14.55 12.4651 13.9266 12.8541C13.5656 13.0792 13.1578 13.2104 12.75 13.2807V14.0823C12.75 14.4948 12.4125 14.8323 12 14.8323C11.5875 14.8323 11.25 14.4948 11.25 14.0823V13.2479C10.725 13.1495 10.2328 12.9807 9.80156 12.8307C9.70312 12.7979 9.60469 12.7651 9.51094 12.7323C9.11719 12.601 8.90625 12.1745 9.0375 11.7854C9.16875 11.3963 9.59531 11.1807 9.98438 11.312C10.1016 11.3495 10.2094 11.387 10.3172 11.4245C10.9547 11.6401 11.4703 11.8182 12.0187 11.8323C12.4453 11.8463 12.8578 11.7526 13.1297 11.5838C13.3688 11.4338 13.5 11.2417 13.4953 10.9276C13.4906 10.712 13.4109 10.562 13.1344 10.3838C12.8156 10.1823 12.3609 10.037 11.775 9.85884L11.7 9.8354C11.1844 9.68071 10.5609 9.49321 10.0688 9.19321C9.50625 8.85571 9.00938 8.30727 9.00469 7.44478C9 6.5354 9.51094 5.90728 10.1203 5.54634C10.4719 5.34009 10.8609 5.20884 11.25 5.13853V4.33228C11.25 3.91978 11.5875 3.58228 12 3.58228C12.4125 3.58228 12.75 3.91978 12.75 4.33228Z"
                        fill="#0073CF"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_2802_3718">
                        <rect width="24" height="24" fill="white"
                              transform="translate(0 0.207275)"/>
                      </clipPath>
                    </defs>
                  </svg>
                  &nbsp;&nbsp;Excess
                </div>
                {(isActive(props.cover1)) && (
                  <div style={{
                    paddingTop: '16px',
                    paddingBottom: '10px',
                    color: 'black',
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center"
                  }}>
                    <div className="regularTextStyles">
                      <Form.Group style={{
                        overflow: 'hidden',
                        display: "flex",
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center"
                      }}>
                        {getExcess(props.cover1, null).map((ex, index) => (
                          <>

                            <Form.Check type="radio"
                                        style={
                                          (isActive(props.cover2)) &&
                                          (isActive(props.cover1)) ? {float: 'left'} : {float: 'left'}
                                        } className='mobile-cover-excess'

                                        label={'$' + ex}
                                        name='cover1_excess'
                                        disabled={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover2}
                                        id={props.cover1 + '_' + ex}
                                        onChange={() => handleExcessChange(props.cover1, ex)}
                                        checked={
                                          (props.inputValues.selectedTermAndCover?.coverName === props.cover1 && props.inputValues.excess === ex) ||
                                          (props.inputValues.selectedTermAndCover?.coverName === props.cover2 &&
                                            (isFirstTime
                                                ? defaultCoverExcess.get(props.cover1) === ex
                                                : (excess.get(props.cover1) ?? defaultCoverExcess.get(props.cover1)) === ex
                                            )
                                          ) ||
                                          (isFirstTime && defaultCoverExcess.get(props.cover1) === ex)
                                        }
                            /></>
                        ))}
                      </Form.Group>
                    </div>
                  </div>)}
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      paddingTop: '16px',
                      paddingBottom: '10px',
                      color: 'black',
                      width: "100%",
                      display: "flex",
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center"
                    }}>
                      <div className="regularTextStyles">
                        <Form.Group style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          overflow: 'hidden'
                        }}>
                          {getExcess(props.cover2, null).map((ex, index) => (
                            <Form.Check type="radio"
                                        style={
                                          (isActive(props.cover2)) &&
                                          (isActive(props.cover1)) ? {float: 'left'} : {float: 'left'}
                                        } className='mobile-cover-excess'
                                        label={'$' + ex}
                                        name='cover2_excess'
                                        disabled={props.inputValues.selectedTermAndCover && props.inputValues.selectedTermAndCover.coverName === props.cover1}
                                        id={props.cover2 + '_' + ex}
                                        onChange={() => handleExcessChange(props.cover2, ex)}
                                        checked={
                                          (props.inputValues.selectedTermAndCover?.coverName === props.cover2 && props.inputValues.excess === ex) ||
                                          (props.inputValues.selectedTermAndCover?.coverName === props.cover1 &&
                                            (isFirstTime
                                                ? defaultCoverExcess.get(props.cover2) === ex
                                                : (excess.get(props.cover2) ?? defaultCoverExcess.get(props.cover2)) === ex
                                            )
                                          ) || (isFirstTime && defaultCoverExcess.get(props.cover2) === ex)
                                        }/>
                          ))}
                        </Form.Group>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="mobile-cover-display-old"
                 style={{
                   height: '50px',
                   display: "flex"
                 }}
            >
              <div className="aaBoldTextStyles"
                   style={{
                     height: '50px',
                     display: "flex",
                     justifyContent: "center",
                     alignItems: 'center',
                     color: isAAPath ? '#005B88' : "white",
                     flex: 1
                   }}>
                Benefits
              </div>
              <div style={{flex: 1}}></div>
              <div style={{flex: 1}}></div>
            </div>
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath ? '#005B88' : '#0C2F63',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                height: "100px"
              }}>
              <div className="benefitsListStyles"
                   style={{
                     display: "flex",
                     flex: 1,
                     justifyContent: "center",
                     alignItems: "center"
                   }}>Individual
                claim limit
                <TooltipTFAF
                  placement="top"
                  title="This is the maximum amount we will pay per claim."
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              <div style={{
                display: "flex", flex: 1,
                justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover1)) && (
                  <div style={{
                    justifyContent: "center",
                    alignItems: "center", color: 'black'
                  }}>
                    <div className="regularTextStyles"
                         style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                      <CheckCircleIcon/>
                      {getClaimLimit(props.cover1, excess.get(props.cover1))}
                    </div>
                  </div>)}
              </div>
              <div style={{
                display: "flex", flex: 1, justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%"
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center",}}>
                        <CheckCircleIcon/>
                        {getClaimLimit(props.cover2, excess.get(props.cover2))}
                      </div>
                    </div>
                  </>)}
              </div>
            </div>

            <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath ? '#005B88' : '#0C2F63',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                height: "100px"
              }}>
              <div className="benefitsListStyles"
                   style={{
                     display: "flex",
                     flex: 1,
                     justifyContent: "center",
                     alignItems: "center"
                   }}>AA Roadservice
                <TooltipTFAF
                  placement="top"
                  title="This free benefit gives you 24/7, 365 days a year assistance with towing, flat battery, lockouts, lost keys, flat tyres and out of fuel. If your car breaks down, whoever is driving it at the time can call the AA and get roadside assistance."
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              <div style={{
                display: "flex", flex: 1,
                justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover1)) && (
                  <div style={{
                    justifyContent: "center",
                    alignItems: "center", color: 'black'
                  }}>
                    <div className="regularTextStyles"
                         style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                      <CheckCircleIcon/>
                      Yes
                    </div>
                  </div>)}
              </div>
              <div style={{
                display: "flex", flex: 1, justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%"
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <CheckCircleIcon/>
                        Yes
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath ? '#005B88' : '#0C2F63',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                height: "100px"
              }}>
              <div className="benefitsListStyles"
                   style={{
                     display: "flex",
                     flex: 1,
                     justifyContent: "center",
                     alignItems: "center"
                   }}> Additional benefits
                <TooltipTFAF
                  placement="top"
                  title="This is extra cover for components related to access and comfort e.g. self-closing boots, driver assistance and safety e.g. lane departure warning systems, entertainment e.g. audio and visual systems and performance features e.g. active suspension systems."
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              <div style={{
                display: "flex", flex: 1,
                justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover1)) && (
                  <div style={{
                    justifyContent: "center",
                    alignItems: "center", color: 'black'
                  }}>
                    <div className="regularTextStyles"
                         style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                      {getBenefitDescription(props.cover1, 'AdditionalCovers') !== '' ?
                        <><CheckCircleIcon/> Yes </>
                        :
                        <>
                          <CrossCircleIcon/>N/A</>
                      }

                    </div>
                  </div>)}
              </div>
              <div style={{
                display: "flex", flex: 1, justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%"
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {getBenefitDescription(props.cover2, 'AdditionalCovers') !== '' ?
                          <><CheckCircleIcon/> Yes </>
                          :
                          <>
                            <CrossCircleIcon/>N/A</>
                        }

                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath ? '#005B88' : '#0C2F63',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                height: "100px"
              }}>
              <div className="benefitsListStyles"
                   style={{
                     display: "flex",
                     flex: 1,
                     justifyContent: "center",
                     alignItems: "center"
                   }}>Consumable items
                <TooltipTFAF
                  placement="top"
                  title="We’ll pay the costs of sundry items like oils, filters and wheel alignment, if they need to be replaced or carried out to repair your car for your claim."
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              <div style={{
                display: "flex", flex: 1,
                justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover1)) && (<div style={{
                  justifyContent: "center",
                  alignItems: "center", color: 'black'
                }}>
                  <div className="regularTextStyles"
                       style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    {getBenefitDescription(props.cover1, 'ConsumableItems') !== '' ?
                      <><CheckCircleIcon/> Yes </>
                      :
                      <>
                        <CrossCircleIcon/>N/A</>
                    }

                  </div>
                </div>)}
              </div>
              <div style={{
                display: "flex", flex: 1, justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%"
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {getBenefitDescription(props.cover2, 'ConsumableItems') !== '' ?
                          <><CheckCircleIcon/> Yes </>
                          :
                          <>
                            <CrossCircleIcon/>N/A</>
                        }

                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath ? '#005B88' : '#0C2F63',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                height: "100px"
              }}>
              <div className="benefitsListStyles"
                   style={{
                     display: "flex",
                     flex: 1,
                     justifyContent: "center",
                     alignItems: "center"
                   }}>Car repatriation costs
                <TooltipTFAF
                  placement="top"
                  title="We’ll repay you for the costs to return your car back to you if it takes more than 24 hours to repair and you are more than 100kms from home."
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              <div style={{
                display: "flex", flex: 1,
                justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover1)) && (<div style={{
                  justifyContent: "center",
                  alignItems: "center", color: 'black'
                }}>
                  <div className="regularTextStyles"
                       style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    {getBenefitDescription(props.cover1, 'RepatriationCosts') !== '' ?
                      <><CheckCircleIcon/> {getBenefitDescription(props.cover1, 'RepatriationCosts')} </>
                      :
                      <>
                        <CrossCircleIcon/>N/A</>
                    }
                  </div>
                </div>)}
              </div>
              <div style={{
                display: "flex", flex: 1, justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%"
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {getBenefitDescription(props.cover2, 'RepatriationCosts') !== '' ?
                          <><CheckCircleIcon/> {getBenefitDescription(props.cover2, 'RepatriationCosts')} </>
                          :
                          <>
                            <CrossCircleIcon/>N/A</>
                        }
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              style={{
                background: getNextBackgroundColorMobile(),
                textAlign: 'center',
                color: isAAPath ? '#005B88' : '#0C2F63',
                display: "flex",
                justifyContent: "space-between",
                alignItems: 'center',
                height: "100px"
              }}
            >
              <div className="benefitsListStyles"
                   style={{
                     display: "flex",
                     flex: 1,
                     justifyContent: "center",
                     alignItems: "center"
                   }}> Accommodation and travel costs
                <TooltipTFAF
                  placement="top"
                  title="We’ll repay you for the costs of accommodation and return home travel if your car takes more than 24 hours to repair and you are more than 100kms from home."
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              <div style={{
                display: "flex", flex: 1,
                justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover1)) && (<div style={{
                  justifyContent: "center",
                  alignItems: "center", color: 'black'
                }}>
                  <div className="regularTextStyles"
                       style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    {getBenefitDescription(props.cover1, 'AccommodationAndReturnHomeTravel') !== '' ?
                      <>
                        <CheckCircleIcon/> {getBenefitDescription(props.cover1, 'AccommodationAndReturnHomeTravel')} </>
                      :
                      <>
                        <CrossCircleIcon/>N/A</>
                    }
                  </div>
                </div>)}
              </div>
              <div style={{
                display: "flex", flex: 1, justifyContent: "center",
                alignItems: "center"
              }}>
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider" style={{height: "100px"}}></div> : <></>}
                    <div style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: 'black',
                      width: "100%"
                    }}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {getBenefitDescription(props.cover2, 'AccommodationAndReturnHomeTravel') !== '' ?
                          <>
                            <CheckCircleIcon/> {getBenefitDescription(props.cover2, 'AccommodationAndReturnHomeTravel')} </>
                          :
                          <>
                            <CrossCircleIcon/>N/A</>
                        }
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            {props.inputValues.propulsionOptions.includes('ELECTRIC') && (
              <div
                style={{
                  background: getNextBackgroundColorMobile(),
                  textAlign: 'center',
                  color: isAAPath ? '#005B88' : '#0C2F63',
                  paddingTop: '10px',
                  paddingLeft: '10px',
                  paddingRight: '10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}>
                <div style={{
                  display: "flex", flex: 1, justifyContent: "center",
                  alignItems: "center"
                }}>
                  <span className="benefitsListStyles">Electric car package</span>
                  <TooltipTFAF
                    placement="top"
                    title="Cover for auxiliary engine and drive unit (inverter), and dual charger and electric vehicle battery will be provided."
                  >
                    <i className="fa fa-info-circle"/>
                  </TooltipTFAF>
                </div>
                <div className={
                  (isActive(props.cover2)) &&
                  (isActive(props.cover1)) ? 'mobile-dual-cover' : 'mobile-single cover'
                } style={{paddingTop: '16px', paddingBottom: '10px', color: 'black', width: "100%", flex: 1,}}>
                  <div className="regularTextStyles"
                       style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <CheckCircleIcon/>
                    Yes
                  </div>
                </div>
                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ? <div className="divider"></div> : <></>}
                    <div className={
                      (isActive(props.cover2)) &&
                      (isActive(props.cover1)) ? 'mobile-dual-cover' : 'mobile-single cover'
                    } style={{paddingTop: '16px', paddingBottom: '10px', color: 'black', width: "100%", flex: 1,}}>
                      <div className="regularTextStyles"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <CheckCircleIcon/>
                        Yes
                      </div>
                    </div>
                  </>
                )}
              </div>)}
            {(props.cover1 === 'Extreme Plus' || props.cover2 === 'Smart Cover') &&
              <div
                style={{
                  background: getNextBackgroundColorMobile(),
                  textAlign: 'center',
                  color: isAAPath ? '#005B88' : '#0C2F63',
                  paddingTop: '10px',
                  paddingLeft: '10px',
                  paddingRight: '10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: "center"
                }}
              >
                <div className="boldTextStyles"
                     style={{
                       flex: 1,
                       display: "flex",
                       justifyContent: "center",
                       alignItems: "center"
                     }}> Download
                  policy book
                </div>
                {(isActive(props.cover1)) && (<div className={
                  (isActive(props.cover2)) &&
                  (isActive(props.cover1)) ? 'mobile-dual-cover' : 'mobile-single cover'
                } style={{
                  paddingTop: '16px',
                  paddingBottom: '10px',
                  color: 'black',
                  width: "100%",
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}>
                  <div className="regularTextStyles">
                    <a
                      href="https://docs.autosure.co.nz/policy_books/autosure/mbi/extreme_plus.pdf"
                      target="_blank" rel="noopener noreferrer"
                      className="text-decoration-none">
                      <svg width="17" height="17" viewBox="0 0 18 20" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M0.350098 18.4004C0.350098 17.7376 0.887356 17.2004 1.5501 17.2004H15.9501C16.6128 17.2004 17.1501 17.7376 17.1501 18.4004C17.1501 19.0631 16.6128 19.6004 15.9501 19.6004H1.5501C0.887356 19.6004 0.350098 19.0631 0.350098 18.4004ZM4.30157 9.15186C4.7702 8.68323 5.53 8.68323 5.99862 9.15186L7.5501 10.7033L7.5501 1.60039C7.5501 0.93765 8.08735 0.400391 8.7501 0.400391C9.41284 0.400391 9.9501 0.937648 9.9501 1.60039L9.9501 10.7033L11.5016 9.15186C11.9702 8.68323 12.73 8.68323 13.1986 9.15186C13.6673 9.62049 13.6673 10.3803 13.1986 10.8489L9.59862 14.4489C9.37358 14.674 9.06836 14.8004 8.7501 14.8004C8.43184 14.8004 8.12661 14.674 7.90157 14.4489L4.30157 10.8489C3.83294 10.3803 3.83294 9.62049 4.30157 9.15186Z"
                              fill="#0073CF"/>
                      </svg>
                      <span style={{verticalAlign: 'sub'}}>{props.cover1}</span>
                    </a>
                  </div>
                </div>)}

                {(isActive(props.cover2)) && (
                  <>
                    {isActive(props.cover2) && isActive(props.cover1) ?
                      <div className="divider"></div> : <></>}
                    <div className={
                      (isActive(props.cover2)) &&
                      (isActive(props.cover1)) ? 'mobile-dual-cover' : 'mobile-single cover'
                    } style={{
                      paddingTop: '16px',
                      paddingBottom: '10px',
                      color: 'black',
                      width: "100%",
                      flex: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}>
                      <div className="regularTextStyles">
                        <a
                          href="https://docs.autosure.co.nz/policy_books/autosure/mbi/smart_cover.pdf"
                          target="_blank" rel="noopener noreferrer"
                          className="text-decoration-none">
                          <svg width="17" height="17" viewBox="0 0 18 20" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M0.350098 18.4004C0.350098 17.7376 0.887356 17.2004 1.5501 17.2004H15.9501C16.6128 17.2004 17.1501 17.7376 17.1501 18.4004C17.1501 19.0631 16.6128 19.6004 15.9501 19.6004H1.5501C0.887356 19.6004 0.350098 19.0631 0.350098 18.4004ZM4.30157 9.15186C4.7702 8.68323 5.53 8.68323 5.99862 9.15186L7.5501 10.7033L7.5501 1.60039C7.5501 0.93765 8.08735 0.400391 8.7501 0.400391C9.41284 0.400391 9.9501 0.937648 9.9501 1.60039L9.9501 10.7033L11.5016 9.15186C11.9702 8.68323 12.73 8.68323 13.1986 9.15186C13.6673 9.62049 13.6673 10.3803 13.1986 10.8489L9.59862 14.4489C9.37358 14.674 9.06836 14.8004 8.7501 14.8004C8.43184 14.8004 8.12661 14.674 7.90157 14.4489L4.30157 10.8489C3.83294 10.3803 3.83294 9.62049 4.30157 9.15186Z"
                                  fill="#0073CF"/>
                          </svg>
                          <span style={{verticalAlign: 'sub'}}>{props.cover2}</span>
                        </a>
                      </div>
                    </div>
                  </>
                )}
              </div>}

            {(props.inputValues.selectedTermAndCover.coverName) && (
              <div style={{
                textAlign: 'center',
                padding: '32px 24px 32px 24px',
                background: isAAPath ? '#ffd400' : '#006EB8',
                color: isAAPath ? '#1851A3' : "white",
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                               <span
                                 className="mediumTextStyles"
                               >
                                 {props.inputValues.selectedTermAndCover.coverName}<br/> {props.inputValues.selectedTermAndCover.term !== undefined && <>
                                 {props.inputValues.selectedTermAndCover.term / 12} {props.inputValues.selectedTermAndCover.term / 12 === 1 ? ' year selected' : ' years selected'} </>}
                                </span>
              </div>)}
          </div>
        </div>
      </div>
      <div style={{
        display: 'flex', justifyContent: 'center', paddingTop: '30px'
      }}>
      </div>

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div style={{width: "838.16px"}}>
          <div>
            <div>
              {(props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER') &&
                <span className="regularTextStyles" style={{
                  paddingTop: '30px',
                  textAlign: 'center'
                }}>
                                Find out about the full terms, exclusions and conditions in the&nbsp;
                  <a href={policyLink()}
                     target="_blank" rel="noopener noreferrer">policy wording</a>.
                                <br/></span>

              }

              <br/>
              <div className="boldTextStyles">Important Information</div>
              <ul>
                <li className="regularTextStyles"><b>Pre-existing issues:</b> Not covered if they existed
                  before purchasing this insurance
                </li>
                <li className="regularTextStyles"><b>Your responsibilities:</b> Vehicle servicing and
                  maintenance
                </li>
                <li className="regularTextStyles"><b>Cancellations:</b> Cancel within 15 days for a refund,
                  if you haven't claimed
                </li>
              </ul>
              <div className="regularTextStyles">Payment can be made by credit card or debit card to
                Autosure Insurance
                Limited. All amounts are in New Zealand dollars and include GST.
              </div>
              <br/>
              <div className="regularTextStyles">This is a summary only. See policy books for full terms, exclusions,
                conditions and
                benefits.
              </div>
              {props.inputValues.source === 'GASPY' && gaspyPromoEnabled && (
                <div className="mt-3 text-start">
                  <a href="https://autosure.co.nz/gaspy-free-fuel-promo-tcs" target="_blank" rel="noopener noreferrer">
                    <img
                      src={gaspyLearnMore}
                      alt="Free Fuel with Gaspy MBI - Limited Time Offer"
                      className="h-auto d-block"
                      style={{width: '450px'}}
                    />
                  </a>
                </div>
              )}
            </div>
          </div>
          <br/>
          <div>
            <div style={{paddingBottom: "10px"}}>
              <span className="boldTextStyles"> Have you selected your choice at the top of this page?</span>
            </div>
            <div>
              <ul className="regularTextStyles">
                <li style={{paddingBottom: "5px"}}>Yes - great simply click ‘Next’ to continue</li>
                {/*<li style={{paddingBottom:"5px"}}>If you want to think about it <br/> <span style={{ color: '#0073CF' ,  textDecoration: "underline", cursor: "pointer",}} onClick={() => saveAndEmailQuote()}> Save & email my quote </span></li>*/}
                <li style={{paddingBottom: "5px"}}>Or you can protect another car <span style={{
                  color: '#0073CF', textDecoration: "underline",
                  cursor: "pointer",
                }}
                                                                                        onClick={handleNewQuoteClick}>
                      Get another quote
                            </span>
                </li>
                {props.inputValues.source === 'TFAF' &&
                  <li style={{paddingBottom: "5px"}}>If you’d like to return to this quote later,
                    click ‘Get Quote’ in the email we sent you
                    until {new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString("en-GB", {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })}.</li>}
              </ul>
            </div>
          </div>
          {!isTurners && props.inputValues.saveQuoteButtonEnabled &&
            <p
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: "center",
                paddingTop: '32px'
              }}>
              <SaveEmailQuote showEmailPopup={showEmailPopup} setShowEmailPopup={setShowEmailPopup}
                              inputValues={props.inputValues}/>
              <button
                onClick={() => saveAndEmailQuote()}
                style={{
                  color: 'white',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                  borderRadius: 6,
                  paddingLeft: 25,
                  paddingRight: 25,
                  paddingTop: 13,
                  paddingBottom: 13,
                  overflow: 'hidden',
                  border: '1px white solid',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'inline-flex',
                  width: "100%",
                  maxWidth: "200px",
                  background: props.inputValues.selectedTermAndCover ? '#AFAFb0' : '#AFAFb0',
                  cursor: props.inputValues.selectedTermAndCover ? 'pointer' : 'not-allowed',
                }}
                disabled={!props.inputValues.selectedTermAndCover}
              >
                Save & email quote
              </button>

            </p>
          }
          <p
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: "center",
              paddingTop: '10px'
            }}>


            <button
              className="float-end"
              onClick={() => props.prevStep()}
              style={{
                color: '#1851A3',
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 13,
                paddingBottom: 13,
                background: 'white',
                border: '1px #1851A3 solid',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
                wordWrap: 'break-word',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: 6,
                width: "100%",
                maxWidth: "200px"
              }}
            >
              Back
            </button>

            <button
              onClick={() => clickNext()}
              style={{
                color: 'white',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: 6,
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 13,
                paddingBottom: 13,
                overflow: 'hidden',
                border: '1px white solid',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
                width: "100%",
                maxWidth: "200px",
                background: props.inputValues.selectedTermAndCover ? isAAPath ? '#005B88' : '#0073CF' : '#B0C4DE',
                cursor: props.inputValues.selectedTermAndCover ? 'pointer' : 'not-allowed',
              }}
              disabled={!props.inputValues.selectedTermAndCover}
            >
              Next
            </button>

          </p>
        </div>
      </div>
      <DeclarationPopupTFAF
        parentDeclarationPopupShow={declarationPopupShow}
        setParentDeclarationPopupShow={setDeclarationPopupShow}
        setParentShowDeclStatement={setShowDeclStatement}
        parentNextStep={props.nextStep}
        source={props.inputValues.source}
      />
    </Container>
  );
}
export default PolicyDetailsTFAF;
